import storage from '@didi/didi-store'
import store from '@/store'
import router from '@/router'
import Passport, { getContractor, getDefaultGlobalParams } from './h5passport'
import ERROR_CODE from '@/config/passport/error-code'
import { PASSPORT_INFO_KEY, CURRENT_SHOP_ID_KEY } from '@/config/passport/config'
import { getRegion } from '@/utils/common/locale.js'
import { getVueInstance } from '@/utils/bridge/vue-instance.js'

const vueInstance = getVueInstance()

const toast = (msg = '') => {
  vueInstance
    .$createGoToast({
      text: msg,
    })
    .show()
}

/**
 * @name 设置debug的div,加到body里
 */
const addDebugSettingDiv = () => {
  const settingElementStr = `
    <div class="setting">
      <i class="icon-v3_filled_settings"></i>
    </div>
  `
  const parentDiv = document.createElement('div')
  parentDiv.innerHTML = settingElementStr
  const settingElement = parentDiv.childNodes[1]
  document.body.appendChild(settingElement)
  settingElement.addEventListener('click', function (e) {
    router.push('/debug')
  })
}

/**
 * @name 获取当前账号下，所有主体
 */

const getContractors = async () => {
  try {
    const res = await getContractor()
    const { errno, data, errmsg } = res
    if (errno === 0) {
      const { contractors = [] } = data
      return contractors
    }
    let errorMessage = errmsg
    switch (errno) {
      case ERROR_CODE.NOT_LOGIN:
      case ERROR_CODE.NO_TOKEN:
        errorMessage = '登录过期，请重新登录'
        break
      case ERROR_CODE.NO_RELEATED_SHOPS:
        errorMessage = '账号未关联门店，请检查账号！'
        break
      default:
        if (ERROR_CODE.GET_SHOP_INFO_FAILED.includes(errno)) {
          errorMessage = '获取账号下门店信息失败！'
        }
    }
    toast(errorMessage)
    return null
  } catch (err) {
    return null
  }
}

/**
 * @name 获取是否需要进入到选择门店页面
 * @desc 1 单门店用户不需要选择 2 多门店用户，如果之前已经选择过门店，就不用，否则跳转选择门店页面
 */
const getNeedSelectShop = contractors => {
  const currentShopId = storage.get(CURRENT_SHOP_ID_KEY)
  const isOneShop = contractors.length === 1 && contractors[0].shops.length === 1 // 单门店用户
  if (isOneShop) {
    return false
  }
  if (!currentShopId) {
    return true
  }
  const shopExists = !!contractors.find(contractor => {
    return contractor.shops.find(shop => shop.shopId === currentShopId)
  })
  return !shopExists
}

/**
 * @name 获取当前账号下，选择的主体和门店信息
 * @desc 如果storage里有上次选择的门店信息，则为默认门店，如果没有，则选择第一个主体下，第一个门店
 */

const getCurrentContractorAndShop = contractors => {
  const currentShopId = storage.get(CURRENT_SHOP_ID_KEY)
  let contractor = contractors[0]
  let shop = contractor.shops[0]
  if (currentShopId) {
    contractors.find(contractorItem => {
      const currentShop = contractorItem.shops.find(shop => {
        return shop.shopId === currentShopId
      })
      if (currentShop) {
        shop = currentShop
        contractor = contractorItem
      }
      return !!currentShop
    })
  }
  return {
    contractor,
    shop,
  }
}

const passportLogin = async resolve => {
  // 从地址读取国家
  const country = getRegion()
  store.commit('UPDATE_CURRENT_COUNTRY', country)
  store.commit('UPDATE_GLOBAL_PARAMS', getDefaultGlobalParams())

  // 获取当前 storage 是否有登录信息
  const loginInfo = storage.get(PASSPORT_INFO_KEY)

  // 不存在登录信息
  if (!loginInfo) {
    return Passport.forceLogin(() => {})
  }

  const contractors = await getContractors()
  if (!contractors || !contractors.length) {
    return Passport.goToLogout()
  }

  const needSelect = getNeedSelectShop(contractors)
  const { contractor, shop } = getCurrentContractorAndShop(contractors)
  const { contractorId } = contractor
  const { shopId, shopName, cityId, countryCode, countryId, businessType } = shop
  store.commit(
    'UPDATE_GLOBAL_PARAMS',
    getDefaultGlobalParams({
      shopId,
      shopName,
      cityId,
      countryCode,
      countryId,
      contractorId,
      shopBusinessType: businessType,
    }),
  )
  store.commit('UPDATE_PASSPORT_CONTRACTORS', contractors)
  store.commit('UPDATE_CURRENT_CONTRACTOR', contractor)
  store.commit('UPDATE_CURRENT_SHOP', shop)
  addDebugSettingDiv()
  // 如果需要选择门店，则跳转门店列表页面
  if (needSelect) {
    router.push('/debug/select-shop') // 异步，在vue未初始化，不会抛出promise
    return setTimeout(() => {
      resolve()
    }, 200)
  }
  resolve()
}

export { passportLogin }
